import { render, staticRenderFns } from "./exactList.vue?vue&type=template&id=5c50d1e2&"
import script from "./exactList.vue?vue&type=script&lang=js&"
export * from "./exactList.vue?vue&type=script&lang=js&"
import style0 from "./exactList.vue?vue&type=style&index=0&id=5c50d1e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports